define('shared/remote/payment/adyen/getStoredTokens',[
    'shared/remote/ajax',
    'shared/my/cmus'
], function (
    ajax,
    getCMus
) {
        return function () {
            return getCMus()
                .then(function(cmus) {
                    return ajax({
                        url: '/services/commerce-v4/offermanager/GetTokenSummary',
                        method: 'post',
                        data: {
                            "cmus": cmus
                        },
                    });
                });
        };
    });

